<template>
  <tr>
    <td>
      <span v-if="rate.rateable_id">
        {{ rate.label }}
      </span>

      <template v-else-if="group.name === 'ancillary'">
        <selectlist
          v-if="isLabelInAncillaryOptions"
          :options="ancillaryLabelOptions"
          :name="`rates[${rate.id}][label]`"
          placeholder="Please Select"
          label-name="label"
          key-name="label"
          :value="ratesForm.rates[rate.id].label"
          @input="setName($event, ratesForm.rates[rate.id])"
        ></selectlist>
        <inputbox
          v-else
          :name="`rates[${rate.id}][label]`"
          :value="ratesForm.rates[rate.id].label"
          @input="setName($event, ratesForm.rates[rate.id])"
        ></inputbox>
      </template>

      <inputbox
        :name="`rates[${rate.id}][label]`"
        :value="ratesForm.rates[rate.id].label"
        @input="setName($event, ratesForm.rates[rate.id])"
        v-else
      ></inputbox>
    </td>
    <td>
      {{ rate.daily_rate | currency }}
    </td>
    <td>
      <template v-if="rate.daily_rate">
        {{ days }}
      </template>
    </td>
    <td>
      <template v-if="rate.rateable_id">
        {{ rate.value | currency }}
      </template>

      <div class="row" v-else>
        <currency-input
          :name="`rates[${rate.id}][value]`"
          v-model="ratesForm.rates[rate.id].value"
        ></currency-input>
      </div>
    </td>
    <td>
      <div class="row">
        <currency-input
          :name="`rates[${rate.id}][agreed_value]`"
          v-model="ratesForm.rates[rate.id].agreed_value"
        ></currency-input>
      </div>
    </td>
    <td>
      {{ rate.total_paid | currency }}
    </td>
    <td>
      <selectlist
        :options="shortFallReasons"
        :name="`rates[${rate.id}][short_fall_reason_id]`"
        placeholder="Please Select"
        label-name="label"
        key-name="id"
        v-model="ratesForm.rates[rate.id].short_fall_reason_id"
      ></selectlist>
    </td>
    <td>
      <button
        class="btn-sm btn-danger"
        @click="emitRemoveRate()"
        v-if="!rate.rateable_id"
      >
        <i class="material-icons">delete</i>
      </button>
    </td>
  </tr>
</template>
<script>
import CurrencyInput from '@/components/Generic/Form/CurrencyInput';

export default {
  props: {
    rate: {
      type: Object,
      required: true
    },
    group: {
      type: Object,
      required: true
    },
    ratesForm: {
      type: Object,
      required: true
    },
    hireForm: {
      type: Object,
      required: true
    }
  },

  components: {
    CurrencyInput
  },

  computed: {
    ancillaryLabelOptions() {
      return [
        { label: 'LOU Client' },
        { label: 'LOU LGA' },
        { label: 'Loss of profit' },
        { label: 'Excess' },
        { label: 'PAV Hire Bike' }
      ];
    },

    isLabelInAncillaryOptions() {
      const currentLabel = this.ratesForm.rates[this.rate.id]?.label;
      if (!currentLabel) {
        return true;
      }
      return this.ancillaryLabelOptions.some(
        option => option.label === currentLabel
      );
    },

    shortFallReasons() {
      return this.$store.getters['ShortFallReasons/all'].filter(
        reason =>
          !reason.rate_group_id || reason.rate_group_id === this.group.id
      );
    },

    days() {
      if (this.group.name === 'hire') {
        return this.hireForm.total_days || 0;
      }

      return null;
    }
  },

  methods: {
    setName(label, rate) {
      rate.label = label;
      rate.name = label ? this.toSlug(label) : '';
    },

    toSlug(value) {
      return value
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/__+/g, '-')
        .replace(/^_+/, '')
        .replace(/_+$/, '');
    },

    emitRemoveRate() {
      this.$emit('remove', this.rate);
    }
  }
};
</script>
